module.exports = __webpack_public_path__ + "static/media/CTK-BNB.7b8820f6.svg";